import * as $ from "jquery";

export class EnrollSelectLiveOnline {
    calendar: string;
    $modal: JQuery;

    constructor(calendar: string) {
        const self = this;
        self.$modal = $(".modal");
        self.calendar = calendar;

        // calendar buttons
        $(".term").on("click", ".modal-trigger", function () {
            const $img = $(this);
            self.showCalendar(
                parseInt($img.data("courseid")),
                $img.data("coursename"),
            );
        });

        const $modelclose = this.$modal.find(".fa");
        const $modelmask = this.$modal.find(".mask");

        $modelclose.on("click", function () {
            self.$modal.hide();
        });
        $modelmask.on("click", function () {
            self.$modal.hide();
        });
    }

    /* ---- CALENDAR TOGGLE ---- */
    showCalendar(id: number, name: string) {
        // Load calendar data into modal
        $(".target").load(this.calendar + id);
        this.$modal.find(".title h1").text(name);
        this.$modal.fadeIn().css("display", "flex");
    }
}
